<template>
<div>
  <el-tag type="primary" v-if="status===10">新建</el-tag>
  <el-tag type="warning" v-if="status===13">已发送</el-tag>
  <el-tag type="warning" v-if="status===200">已结束</el-tag>
</div>
</template>

<script>
export default {
  name: 'send-status',
  props:{
    status:{
      type:Number,
      default:null
    }
  }
}
</script>

<style scoped>

</style>
